// @ts-nocheck
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getDvrTime } from 'support/mediaTileHelper';
import { parseDate } from 'common/support/dateHelper';
import useInterval from 'hooks/interval';

import dvrBackgroundSrc from 'assets/images/tile/dvr_bg.png';

import MediaTile from './MediaTile';

import styles from './DvrTile.module.scss';

const messages = {
  d: {
    id: 'tile.dvrTime.dayAgo',
    description: 'dvr time',
  },
  dLong: {
    id: 'tile.dvrTime.dayAgoLong',
    description: 'dvr time',
  },
  h: {
    id: 'tile.dvrTime.hourAgo',
    description: 'dvr time',
  },
  hLong: {
    id: 'tile.dvrTime.hourAgoLong',
    description: 'dvr time',
  },
  m: {
    id: 'tile.dvrTime.minuteAgo',
    description: 'dvr time',
  },
  mLong: {
    id: 'tile.dvrTime.minuteAgoLong',
    description: 'dvr time',
  },
  s: {
    id: 'tile.dvrTime.secondAgo',
    description: 'dvr time',
  },
  sLong: {
    id: 'tile.dvrTime.secondAgoLong',
    description: 'dvr time',
  },
  nowPlaying: {
    id: 'tile.nowPlaying',
    description: 'Text for now playing video flag',
  },
};

const DvrTile = ({ title, timeSeconds, src, size, isNowPlaying, ...rest }) => {
  const intl = useIntl();

  const getTimeString = () => {
    const timeInfo = getDvrTime(parseDate(timeSeconds * 1000)) || {};
    const { value, unit } = timeInfo;
    const msg = messages[unit];
    const msgLong = messages[`${unit}Long`];
    if (msg) {
      return {
        display: `${value}${intl.formatMessage(msg)}`,
        tts: intl.formatMessage(msgLong, { value }),
      };
    }
    return {};
  };

  const [timeString, setTimeString] = useState(getTimeString());

  useInterval(() => {
    setTimeString(getTimeString(), 60000);
  });

  const renderMetadata = () => {
    return (
      <div
        className={classNames(
          'h-100 w-100',
          'd-flex flex-column',
          'align-items-start justify-content-between',
          'text-left',
          styles.wrapper,
        )}
      >
        <div
          className={classNames('text-wrap', 'overflow-hidden', styles.title)}
          data-testid="metadata"
        >
          {title}
        </div>
        <div
          className={classNames(
            'd-flex flex-row',
            'justify-content-center',
            styles.time,
          )}
          data-testid="dvr-time"
        >
          {timeString.display}
        </div>
      </div>
    );
  };

  const tts = [
    isNowPlaying ? intl.formatMessage(messages.nowPlaying) : null,
    title,
    timeString.tts,
  ]
    .filter(item => item)
    .join(', ');

  return (
    <MediaTile
      {...rest}
      src={src || dvrBackgroundSrc}
      autoSizeSrc={Boolean(src)}
      renderMetadata={renderMetadata}
      size={size || 'sm'}
      isNowPlaying={isNowPlaying}
      ttsText={tts}
      isDvr
    />
  );
};

DvrTile.propTypes = {
  title: PropTypes.string.isRequired,
  timeSeconds: PropTypes.number.isRequired,
  src: PropTypes.string,
  size: PropTypes.string,
  isNowPlaying: PropTypes.bool,
};

DvrTile.defaultProps = {
  src: null,
  size: null,
  isNowPlaying: false,
};

export default React.memo(DvrTile);
